import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useContent } from '../contexts/ContentContext';
import './About.css';

const About = () => {
  const { i18n } = useTranslation();
  const { content } = useContent();
  const isSk = i18n.language?.startsWith('sk');
  const a = content.about || {};

  return (
    <>
      <Helmet>
        <title>{isSk ? 'O nás | ZEL s.r.o.' : 'About | ZEL s.r.o.'}</title>
        <meta name="description" content={isSk
          ? 'ZEL je fast food značka postavená okolo jednoduchej myšlienky: skvelé jedlo, podávané rýchlo, vždy.'
          : 'ZEL is a fast food brand built around one simple idea: great food, served fast, every time.'} />
        <link rel="canonical" href="https://www.zel.sk/about" />
      </Helmet>

      <Navbar />

      <main className="about-page">
        {/* HERO — matches zel.sk About hero */}
        <section className="about-hero">
          <div className="container">
            <h1 className="about-hero__title">
              {isSk ? 'O nás' : 'About Us'}
            </h1>
          </div>
        </section>

        {/* INTRO — with decorative image */}
        <section className="about-intro section">
          <div className="container about-intro__grid">
            <div className="about-intro__copy">
              <p className="about-intro__lead">
                {isSk
                  ? 'ZEL je fast food značka postavená okolo jednej jednoduchej myšlienky: skvelé jedlo, podávané rýchlo, vždy.'
                  : 'ZEL is a fast food brand built around one simple idea: great food, served fast, every time.'}
              </p>
              <p className="about-intro__body">
                {isSk
                  ? 'Kladieme dôraz na čerstvú prípravu, konzistentnú chuť a vysoké hygienické štandardy — či už si vyberiete dine-in, takeaway alebo doručenie.'
                  : 'The company emphasizes fresh preparation, consistent taste, and high hygiene standards across dine-in, takeaway, and delivery options.'}
              </p>
            </div>
            <div className="about-intro__media">
              <img src={a.decorImage || '/images/about-decor.jpg'} alt="" loading="lazy" />
            </div>
          </div>
        </section>

        {/* FOUNDER — with portrait */}
        <section className="about-founder section">
          <div className="container about-founder__grid">
            <div className="about-founder__photo">
              <img src={a.founderImage || '/images/ali-yildiz.jpg'} alt="Ali Yildiz" loading="lazy" />
            </div>
            <div className="about-founder__copy">
              <h2 className="about-founder__name">Ali Yildiz</h2>
              <p className="about-founder__role">
                {isSk ? 'Stavebný inžinier (MSc) & zakladateľ' : 'Civil Engineer (MSc) & Founder'}
              </p>
              <blockquote className="about-founder__quote">
                {isSk
                  ? '„V jadre ZEL stojí inžinierska disciplína a operatívna excelentnosť. Neposkytujeme len služby; staviame udržateľné, dlhodobé štruktúry, ktoré umožňujú našim značkám a partnerom rásť so sebavedomím."'
                  : '"At the core of ZEL lies engineering discipline and operational excellence. We do not just provide services; we build sustainable, long-term structures that empower our brands and partners to grow with confidence."'}
              </blockquote>
            </div>
          </div>
        </section>

        {/* CTA — exact zel.sk wording */}
        <section className="about-cta">
          <div className="container">
            <h2>{isSk ? 'Postavme niečo, čo funguje' : "Let's Build Something That Works"}</h2>
            <p>
              {isSk
                ? 'Od fast-food prevádzok po stavebné služby — ZEL prináša spoľahlivú realizáciu s jasnou komunikáciou.'
                : 'From fast food operations to construction services, ZEL delivers reliable execution with clear communication.'}
            </p>
            <Link to="/contact-us" className="btn btn-primary about-cta__btn">
              {isSk ? 'KONTAKTUJTE ZEL' : 'Contact ZEL'} <FaArrowRight />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default About;
